/**
 * HeadDepositModal 헬퍼 함수
 * 입금 모달 관련 유틸리티
 */

import {
    HeadDepositModalProps,
    HeadGetWithdrawableAmountResponseDto
} from '../types/headWithdraw.types';

// ======== 타입 정의 ========

/** 계좌 정보 타입 */
type AccountInfo = HeadDepositModalProps['accountInfo'];

/** 출금 가능 금액 정보 타입 */
type WithdrawableAmount = HeadGetWithdrawableAmountResponseDto | null;

// ======== 스타일 상수 ========

/** 금액 입력 필드 스타일 */
export const AMOUNT_INPUT_STYLE: React.CSSProperties = {
    fontSize: '1.5rem',
    fontWeight: 600,
    flex: 1
};

/** 계좌 정보 행 스타일 */
export const ACCOUNT_ROW_STYLE: React.CSSProperties = {
    marginBottom: '0.5rem'
};

// ======== 계좌 정보 헬퍼 ========

/**
 * 입금 계좌 정보 문자열 생성
 * accountInfo를 우선 사용하고, 없으면 withdrawableAmount에서 가져옴
 * 은행명을 우선 사용하고, 없으면 은행코드를 사용
 */
export const getDepositAccountString = (
    accountInfo: AccountInfo,
    withdrawableAmount: WithdrawableAmount
): string => {
    if (accountInfo?.depositBankCode || accountInfo?.depositAcctNum) {
        const bankName = (accountInfo as any)?.depositBankName || accountInfo.depositBankCode || '';
        const acctNum = accountInfo.depositAcctNum || '';
        const acctName = accountInfo.depositAcctName || '';
        return `[${bankName} ${acctNum} ${acctName}]`;
    }

    const bankName = withdrawableAmount?.depositBankName || 
                     withdrawableAmount?.bankName || 
                     withdrawableAmount?.depositBankCode || 
                     withdrawableAmount?.bankCode || '';
    const acctNum = withdrawableAmount?.depositAcctNum || withdrawableAmount?.acctNum || '';
    const acctName = withdrawableAmount?.depositAcctName || withdrawableAmount?.acctName || '';
    return `[${bankName} ${acctNum} ${acctName}]`;
};

/**
 * 출금 계좌 정보 문자열 생성
 * 은행명을 우선 사용하고, 없으면 은행코드를 사용
 */
export const getWithdrawAccountString = (
    accountInfo: AccountInfo,
    withdrawableAmount: WithdrawableAmount
): string => {
    const bankName = (accountInfo as any)?.withdrawBankName || 
                     accountInfo?.withdrawBankCode || 
                     withdrawableAmount?.withdrawBankName || 
                     withdrawableAmount?.bankName || 
                     withdrawableAmount?.withdrawBankCode || 
                     withdrawableAmount?.bankCode || '';
    const acctNum = accountInfo?.withdrawAcctNum || withdrawableAmount?.withdrawAcctNum || '';
    const acctName = accountInfo?.withdrawAcctName || withdrawableAmount?.withdrawAcctName || '';
    return `[${bankName} ${acctNum} ${acctName}]`;
};

/**
 * 출금 계좌 표시 여부 확인
 */
export const hasWithdrawAccount = (
    accountInfo: AccountInfo,
    withdrawableAmount: WithdrawableAmount
): boolean => {
    return !!(
        accountInfo?.withdrawBankCode ||
        accountInfo?.withdrawAcctNum ||
        withdrawableAmount?.withdrawBankCode
    );
};
